import { Link } from "react-router-dom";
import { ArrowRight, HeartPulse, Users } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Motion";
import PageSeo from "@/components/PageSeo";

export default function Sante() {
  return (
    <div data-testid="sante-page">
      <PageSeo path="/sante" />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 py-16 lg:py-24">
        <Reveal y={12}>
          <SectionTag className="mb-4">Complémentaire santé</SectionTag>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tighter leading-[0.9] mb-6">
            La santé du<br /><span className="text-accent">chef</span> et des<br />salariés.
          </h1>
          <p className="max-w-2xl text-base sm:text-lg leading-relaxed text-ink/75 mb-20">
            Au-delà de la décennale, nous accompagnons les artisans sur la protection santé de
            toute l'entreprise : le dirigeant TNS comme ses salariés.
          </p>
        </Reveal>

        <div className="grid gap-8 lg:grid-cols-2 mb-20">
          <Reveal>
            <div className="flex h-full flex-col border-2 border-ink bg-white p-8 sm:p-12 shadow-brutal">
              <HeartPulse className="h-8 w-8 text-accent mb-6" />
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink/60 mb-3">Loi Madelin</p>
              <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tighter mb-4">
                Santé pour les dirigeants TNS
              </h2>
              <p className="text-sm sm:text-base leading-relaxed text-ink/75 mb-4">
                Travailleur non salarié, vous n'êtes pas couvert par un régime collectif. Une
                complémentaire santé dédiée aux TNS complète les remboursements de l'Assurance
                Maladie : hospitalisation, soins courants, optique, dentaire.
              </p>
              <ul className="space-y-3 text-sm leading-relaxed text-ink/75 mb-8">
                <li className="flex gap-3"><span className="font-mono text-[10px] text-accent pt-1">—</span>Cotisations déductibles du bénéfice imposable (loi Madelin)</li>
                <li className="flex gap-3"><span className="font-mono text-[10px] text-accent pt-1">—</span>Garanties modulables selon votre budget et votre famille</li>
                <li className="flex gap-3"><span className="font-mono text-[10px] text-accent pt-1">—</span>Adaptée aux réalités des métiers du BTP</li>
              </ul>
              <Link
                to="/devis"
                data-testid="sante-tns-cta"
                className="mt-auto inline-flex w-fit items-center gap-2 border-2 border-ink bg-ink px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper transition-colors hover:bg-accent hover:border-accent"
              >
                Demander un devis santé
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex h-full flex-col border-2 border-ink bg-night text-paper p-8 sm:p-12 shadow-brutal-accent">
              <Users className="h-8 w-8 text-accent mb-6" />
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/50 mb-3">Obligation ANI</p>
              <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tighter mb-4">
                Santé pour les salariés
              </h2>
              <p className="text-sm sm:text-base leading-relaxed text-paper/75 mb-4">
                Dès le premier salarié, la loi ANI impose de proposer une complémentaire santé
                collective. Nous vous aidons à mettre en place un régime conforme, financé au
                minimum à 50 % par l'entreprise.
              </p>
              <ul className="space-y-3 text-sm leading-relaxed text-paper/75 mb-8">
                <li className="flex gap-3"><span className="font-mono text-[10px] text-accent pt-1">—</span>Mise en conformité avec l'obligation légale</li>
                <li className="flex gap-3"><span className="font-mono text-[10px] text-accent pt-1">—</span>Un atout pour attirer et fidéliser vos compagnons</li>
                <li className="flex gap-3"><span className="font-mono text-[10px] text-accent pt-1">—</span>Options de renfort adaptées aux métiers physiques</li>
              </ul>
              <Link
                to="/devis"
                data-testid="sante-salaries-cta"
                className="mt-auto inline-flex w-fit items-center gap-2 border-2 border-paper bg-accent border-accent px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper transition-colors hover:bg-transparent"
              >
                Demander un devis collectif
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>
        </div>

        <Reveal className="border border-ink/15 bg-smoke/40 p-8 text-center">
          <p className="text-sm leading-relaxed text-ink/75 max-w-2xl mx-auto">
            <strong>Une question sur la santé TNS ou collective ?</strong> Utilisez le{" "}
            <Link to="/contact" className="underline underline-offset-4 hover:text-accent transition-colors" data-testid="sante-contact-link">
              formulaire de contact
            </Link>{" "}
            ou demandez à être rappelé, ou lancez directement votre demande de devis en
            précisant votre besoin.
          </p>
        </Reveal>
      </div>
    </div>
  );
}
